export const errors = {
  /** `AsyncSection`'s three states. `label` is an already-translated noun
   * phrase the caller supplies via `t()`. */
  loading: 'Loading {{label}}…',
  forbidden: 'You are not allowed to see {{label}}.',
  notFound: 'The {{label}} could not be found.',
  loadingFailed: 'Loading {{label}} failed: {{message}}',
  /** `SubmitError`'s cases. `suffix` is either `': ' + reason` or `'.'`,
   * built in code — the reason text itself comes from the API and is not
   * translated. */
  submitForbidden: 'You are not allowed to do this{{suffix}}',
  submitConflict: 'This conflicts with the current state{{suffix}}',
  submitGeneric: 'Something went wrong: {{message}}',
} as const;
